import { api } from "@/lib/api";

const THRESHOLD = 8 * 1024 * 1024;

export async function uploadFile(file, onProgress = () => {}) {
  if (file.size <= THRESHOLD) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/documents/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => onProgress(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
    });
    return data;
  }
  const { data: init } = await api.post("/uploads/init", { filename: file.name, size: file.size });
  try {
    for (let i = 0; i < init.chunks_total; i++) {
      const blob = file.slice(i * init.chunk_size, Math.min(file.size, (i + 1) * init.chunk_size));
      let attempt = 0;
      for (;;) {
        try {
          await api.put(`/uploads/${init.upload_id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
          break;
        } catch (err) {
          if (++attempt >= 3 || [400, 401, 403, 404].includes(err.response?.status)) throw err;
          await new Promise((r) => setTimeout(r, 800 * attempt));
        }
      }
      onProgress(Math.round(((i + 1) / init.chunks_total) * 95));
    }
    const { data } = await api.post(`/uploads/${init.upload_id}/complete`);
    onProgress(100);
    return data;
  } catch (err) {
    api.delete(`/uploads/${init.upload_id}`).catch(() => {});
    throw err;
  }
}
